<div class="d-flex w-100">
	<div class="mx-auto">
		<img
			[src]="'https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + kioskService.venueService.venueKey + '/logo.png'"
			alt="Kiosk Idle"
			class="img-fluid"
		/>
	</div>
</div>
<div class="d-flex h-100 w-100 justify-content-center" (click)="startOrderEmitter.emit(true)">
	<div class="d-flex h-100">
		<p-button
			[disabled]="!kioskService.venueService.ooVenue"
			class="d-flex p-button-raised p-button-info h-33 my-auto animation-heartbeat animate-count-infinite animate-duration-15s shadow-lg rounded"
		>
			<div class="d-flex justify-content-center text-center mx-auto">
				<fa-icon [icon]="['far', 'utensils-alt']" class="me-5 my-auto" size="2x"></fa-icon>
				<div class="h1 my-auto">Let's start your order</div>
			</div>
		</p-button>
	</div>
</div>
